"use client";
import React, { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import Hero from "./components/hero";
import IntroComponent from "./components/intro";
import MigrationComponent from "./components/migration";
import CustomerReviewComponent from "./components/customerReview";
import MigrationTable from "./components/scenarios";
import WhyOnemindComponent from "./components/whyOnemind";
import InclusionComponent from "./components/inclusion";
import MigrationCta from "./components/migrateCta";

const VmWareMigrationPage = () => {
  return (
    <Fragment>
      <PageLayout>
        <Hero />
        <IntroComponent />
      </PageLayout>
      <MigrationComponent />
      <PageLayout>
        <MigrationTable />
      </PageLayout>
      <Box>
        <InclusionComponent />
        <WhyOnemindComponent />
      </Box>
      <PageLayout showContactForm>
        <CustomerReviewComponent />
        <MigrationCta />
      </PageLayout>
    </Fragment>
  );
};

export default VmWareMigrationPage;
